// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copy-weekly-plan{width:500px}.copy-weekly-plan__form{padding:0 16px 16px}.copy-weekly-plan .modal__controls{margin:20px -16px -20px}`, "",{"version":3,"sources":["webpack://./src/modals/CopyWeeklyPlan/style.scss"],"names":[],"mappings":"AACA,kBACE,WAAA,CAEA,wBACE,mBAAA,CAGF,mCACE,uBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
